// DS2.1
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink, { Props as BaseButtonProps } from '../PlainButtonOrLink';
import { Props as IconProps } from '../../Icons/IconWrap';
import { ButtonSize } from '../types';
import useIconSizeForButtonSize from '../hooks/useIconSizeForButtonSize';
import s from './SolidButton.scss';

export interface Props extends BaseButtonProps {
  size: ButtonSize;
  icon?: React.ComponentType<IconProps>;
  postfixIcon?: React.ComponentType<IconProps>;
  variant: 'main' | 'approval-green' | 'destructive-red' | 'edit-purple' | 'core-orange';
  priority?: 'primary' | 'secondary';
  rounded?: boolean;
  children: React.ReactNode;
}

const SolidButton: React.FC<Props> = ({
  size,
  variant,
  priority = 'primary',
  fillContainerWidth,
  className,
  children,
  icon: IconComponent,
  postfixIcon: PostFixIconComponent,
  loading,
  rounded,
  ...props
}) => {
  const iconSize = useIconSizeForButtonSize(size);

  return (
    <PlainButtonOrLink
      className={classnames(
        className,
        s['root'],
        s[`variant-${variant}`],
        s[`priority-${priority}`],
        s[`size-${size}`],
        fillContainerWidth && s['fill-container-width'],
        props.disabled && s['disabled'],
        loading && s['loading'],
        IconComponent && s['with-prefix-icon'],
        PostFixIconComponent && s['with-postfix-icon'],
        rounded && s['rounded']
      )}
      {...props}
    >
      {IconComponent && (
        <IconComponent className={s['icon']} size={iconSize} disableDefaultColors />
      )}
      <span className={s['content']}>{children}</span>
      {PostFixIconComponent && (
        <PostFixIconComponent className={s['icon']} size={iconSize} disableDefaultColors />
      )}
    </PlainButtonOrLink>
  );
};
SolidButton.displayName = 'SolidButton';

export default SolidButton;
